import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/organizations/invitationVerify';
import config from '../../../config';
import { Error as ErrorAction } from '../../actions/error/error';

const unwrap = (res) => (res && res.data && res.data.data !== undefined ? res.data.data : (res && res.data) || {});

function* operation(action) {
  const { token } = action.payload;
  try {
    // Public endpoint — works logged-out, so no auth headers.
    const res = yield call(
      axios.get,
      `${config.API_URL}/organization/verify-invitation?token=${encodeURIComponent(token)}`,
    );
    yield put(fetchSuccess(unwrap(res)));
  } catch (err) {
    yield put(ErrorAction(err));
    yield put(fetchFailure(
      err?.response?.data?.data?.message
        || err?.response?.data?.message
        || 'This invitation is invalid, expired, or already used.',
    ));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
